export class UpdateCourseGeneralInfoDto{
  name: string;
  description: string;
  startDifficulty: number;
  endDifficulty: number;
  danceStyleIds: string[];
  tags?: string[];
}
